// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"styles_modalContent__2Zukp","affected":"styles_affected__36hbI","conflicts":"styles_conflicts__1oRFG","fileName":"styles_fileName__4QZIb"};